// extracted by mini-css-extract-plugin
export default {"fonts-table":"styles_fonts-table__IEkkw","center":"styles_center__jyBca","error-message":"styles_error-message__bmpYB"};